import { useState, useCallback, useMemo } from "react";
import { useSettingGroups } from "./useSettings";
import { GROUP_TITLE } from "../settings/groups";

export interface SettingItem {
  id: string; // SettingRow id
  label: string;
  description?: string;
  sectionId: string; // nav 그룹 선택용
  sectionTitle: string; // 표시용
}

export function useSettingSearch() {
  const groups = useSettingGroups();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<SettingItem[]>([]);
  const [highlightedId, setHighlightedId] = useState<string | null>(null);

  const items = useMemo<SettingItem[]>(
    () =>
      groups.flatMap(({ group, entries }) =>
        entries.map((e) => ({
          id: e.key,
          label: e.def.title,
          description: e.def.description,
          sectionId: group,
          sectionTitle: GROUP_TITLE[group] ?? group,
        })),
      ),
    [groups],
  );

  const search = useCallback(
    (q: string) => {
      setQuery(q);
      if (!q.trim()) {
        setResults([]);
        return;
      }
      const lower = q.toLowerCase();
      setResults(
        items.filter(
          (s) =>
            s.label.toLowerCase().includes(lower) ||
            s.description?.toLowerCase().includes(lower) ||
            s.sectionTitle.toLowerCase().includes(lower),
        ),
      );
    },
    [items],
  );

  const navigateTo = useCallback((item: SettingItem) => {
    setQuery("");
    setResults([]);
    setTimeout(() => {
      setHighlightedId(item.id);
      setTimeout(() => setHighlightedId(null), 2000);
    }, 300);
  }, []);

  return { query, results, search, navigateTo, highlightedId };
}
